import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=36cb7de3&"
import script from "./PlayerVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports